<template>
    <section class="ticket-teaser stretch-link ">
        <div class="position-relative">
            <div class="ratio ratio-ticket-teaser img-scroll-zoom-wrapper">
                <img class="ratio-item ticket-teaser__img js-img-scroll-zoom js-lazy-img" :src="imgSrc" loading="lazy" width="312" height="209">
            </div>
        </div>

        <div class="ticket-teaser__body">
            <div class="ticket-teaser__top-title">
                {{ topTitle }}
            </div>

            <h3 class="ticket-teaser__title">
                <a href="" class="stretch-link__link" data-event-tracking-key="click-select-item-3000188">
                    {{ title }}
                </a>
            </h3>

            <div class="ticket-teaser__price">
                {{ translate('shop.crossselling.price-from') }} {{ price }} {{ currency }}
            </div>
            <div class="row">
                <a :href="url" class="btn btn-secondary w-100" data-event-tracking-key="click-product-teaser-learn-more-3000188">
                    {{ translate('shop.crossselling.learn-more') }}
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import LoadingSpinner from "../loading/LoadingSpinner.vue";
import {defineComponent} from 'vue';
import { translate } from '@elements/translations';

export default defineComponent({
    name: 'TicketTeaser',
    components: {
        LoadingSpinner,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        topTitle: {
            type: String,
            required: true,
        },
        price: {
            type: Number,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        imgSrc: {
            type: String,
            required: true
        },
        currency: {
            type: String,
            default: 'CHF'
        }
    }, setup(props) {
        return {
            translate
        }
    }
})
</script>